import { render, staticRenderFns } from "./HeaderTypes.vue?vue&type=template&id=16cc3c70&"
import script from "./HeaderTypes.vue?vue&type=script&lang=ts&"
export * from "./HeaderTypes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports